<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="6">
      <v-card class="home pa-5" outlined>
        <v-card-title>
          <h1>Verify Your Phone</h1>
        </v-card-title>
        <v-card-text class="customer-verification-form">
          <v-form
            @submit.prevent="verify"
            v-model="isFormValid"
            class="customer-verification-form"
          >
            <v-otp-input
              v-model="code"
              class="code-input mt-4 mb-2"
              color="blue darken-1"
              label="5-Digit Code"
              large
              length="5"
              :rules="[
                ValidationRules.requiredString,
                ValidationRules.userCodeLength,
              ]"
            />
            <transition name="fade" mode="out-in">
              <div v-if="error" class="red--text mb-2">{{ error }}</div>
            </transition>
            <v-btn
              color="blue darken-2"
              :disabled="!isFormValid"
              class="white--text"
              :loading="loading"
              depressed
              x-large
              block
              type="submit"
              >Verify</v-btn
            >
            <v-btn
              v-if="error"
              color="blue darken-2"
              class="white--text mt-4"
              :loading="loading"
              @click="resendCode"
              text
              block
              >Resend Code</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import ValidationRules from '@/constants/ValidationRules'
import { CustomerRoutes } from '@/constants/RouteNames'

export default {
  name: 'LoginVerifyPhoneView',
  components: {},
  data: () => {
    return {
      isFormValid: false,
      loading: false,
      error: false,
      code: '',
      ValidationRules,
    }
  },
  created() {
    this.phone = this.$route.params.phone
  },
  methods: {
    ...mapActions('customer', ['sendCode', 'verifyPhone']),

    async verify() {
      this.loading = true
      this.error = false
      try {
        let verificationResponse = await this.verifyPhone({
          phone: this.phone,
          code: this.code,
        })
        this.loading = false
        if (verificationResponse.verified) {
          // If somehow user has already set a password
          if (verificationResponse.email && verificationResponse.pass) {
            this.$router.push({
              name: CustomerRoutes.LOGIN_EMAIL_HINT,
              params: { emailHint: verificationResponse.email },
              query: { codeVerified: 1 },
            })
          }
          // If user has email but no password
          else if (verificationResponse.email) {
            this.$router.push({
              name: CustomerRoutes.LEGACY_UPDATE,
              params: {
                emailHint: verificationResponse.email,
                phone: this.phone,
              },
              query: { codeVerified: 1 },
            })
          }
          // If user is missing both email and password
          else {
            this.$router.push({
              name: CustomerRoutes.LEGACY_UPDATE_NO_EMAIL,
              params: {
                phone: this.phone,
              },
              query: { codeVerified: 1 },
            })
          }
        } else {
          this.error = `The code was incorrect. Try again or request another code.`
        }
      } catch (error) {
        this.error = `The code was incorrect. Try again or request another code.`
      }
    }, // verify

    async resendCode() {
      this.loading = true
      this.error = false
      try {
        let wasCodeSent = await this.sendCode(this.phone)
        this.loading = false
        if (wasCodeSent) {
          // console.log('code sent')
          this.error = false
        }
      } catch (error) {
        this.error = `A new code could not be sent. Please try again.`
      }
    }, // resendCode
  },
}
</script>

<style lang="css">
.customer-verification-form input {
  font-size: 2em;
  line-height: 1.3 !important;
  max-height: none !important;
}
</style>
